import Box from "@mui/material/Box";
import { CircularProgress, Grid, TextField, Typography } from "@mui/material";
import AppButton from "../../common/AppButton";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { addCustomerInitialValues } from "../../forms/initialValues";
import { Formik, Form, Field } from "formik";
import { useEffect, useState } from "react";
import React from "react";
import { editCustomerValidationSchema } from "../../forms/validationSchemas";
import { theme } from "../../../theme";
import { editCustomer } from "../../../features/customerHistory/customerHistorySlice";

interface IProps {
  handleClose: () => void;
  setOpenSnackbar: any;
  getCustomerHistory: () => void;
  customerInfo: any;
}

const EditCustomerModal = ({
  handleClose,
  getCustomerHistory,
  setOpenSnackbar,
  customerInfo,
}: IProps) => {
  const dispatch = useAppDispatch();
  const { isCustomerLoading }: any = useAppSelector((state) => state.customer);
  const [test, setTest] = useState(addCustomerInitialValues);
  const pharmacyId = localStorage?.getItem("pharmacyId");
  useEffect(() => {
    setTest({
      pharmacy_id: pharmacyId,
      id: customerInfo?.id,
      name: customerInfo?.name || "",
      phone_number: customerInfo?.phone_number || "",
      // email: customerInfo?.email || "",
    });
  }, [customerInfo]);

  const handleSubmit = async (values: any) => {
    const { id, name, phone_number, email, pharmacy_id } = values;
    const customer: any = {
      id: id,
      name: name,
      phone_number: phone_number,
      // email: email,
      pharmacy_id: pharmacy_id,
    };

    try {
      const res = await dispatch(editCustomer(customer));
      if (res?.payload?.success === true) {
        setOpenSnackbar();
        getCustomerHistory();
        handleClose();
      } else {
        window.alert("Failed to update Customer. Please try again.");
      }
    } catch (error) {
      console.error("Error adding Customer: ", error);
    }
  };

  return (
    <Formik
      initialValues={test}
      enableReinitialize={true}
      validationSchema={editCustomerValidationSchema}
      onSubmit={handleSubmit}
    >
      {({ errors, touched }) => (
        <Form>
          <Box sx={{ mt: 0.5 }}>
            <Grid container spacing={2}>
              {/* Supplier Name/Company Field */}
              <Grid item xs={12} sm={6}>
                <Typography
                  sx={{
                    fontSize: "16px",
                    fontWeight: "500",
                    lineHeight: "100%",
                    color: "#333333",
                    fontFamily: theme.typography.fontFamily,
                  }}
                  gutterBottom
                >
                  Name
                </Typography>
                <Field
                  as={TextField}
                  fullWidth
                  variant="outlined"
                  name="name"
                  placeholder="Customer name"
                  inputProps={{ style: { padding: "10px 12px" } }}
                  error={touched.name && Boolean(errors.name)}
                  helperText={touched.name && errors.name}
                  onInput={(e: any) => {
                    const input = e.target as HTMLInputElement;
                    input.value = input.value.replace(/[^a-zA-Z\s]/g, ""); // allow only letters and spaces
                  }}
                />
              </Grid>

              {/* Contact Person Field */}
              <Grid item xs={12} sm={6}>
                <Typography
                  sx={{
                    fontSize: "16px",
                    fontWeight: "500",
                    lineHeight: "100%",
                    color: "#333333",
                    fontFamily: theme.typography.fontFamily,
                  }}
                  gutterBottom
                >
                  Number
                </Typography>
                <Field
                  as={TextField}
                  fullWidth
                  variant="outlined"
                  name="phone_number"
                  placeholder="03xx xxxxxxx"
                  inputProps={{
                    style: { padding: "10px 12px" },
                    maxLength: 11, // limit to 11 digits
                    inputMode: "numeric", // for mobile devices to show number keypad
                  }}
                  error={touched.phone_number && Boolean(errors.phone_number)}
                  helperText={touched.phone_number && errors.phone_number}
                  onInput={(e:any) => {
                    const input = e.target as HTMLInputElement;
                    input.value = input.value.replace(/\D/g, ""); // remove non-digits
                  }}
                />
              </Grid>

              {/* Email Field */}
              {/* <Grid item xs={12} sm={12}>
                <Typography
                  sx={{
                    fontSize: "16px",
                    fontWeight: "500",
                    lineHeight: "100%",
                    color: "#333333",
                    fontFamily: theme.typography.fontFamily,
                  }}
                  gutterBottom
                >
                  Email
                </Typography>
                <Field
                  as={TextField}
                  fullWidth
                  variant="outlined"
                  name="email"
                  placeholder="123@xx.com"
                  inputProps={{ style: { padding: "10px 12px" } }}
                  error={touched.email && Boolean(errors.email)}
                  helperText={touched.email && errors.email}
                />
              </Grid> */}
            </Grid>
          </Box>
          <Box sx={{ mt: 1.5 }}>
            <AppButton
              variant="contained"
              color="primary"
              type="submit"
              title={
                isCustomerLoading ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  "Update"
                )
              }
              sx={{ float: "right" }}
            />
          </Box>
        </Form>
      )}
    </Formik>
  );
};

export default EditCustomerModal;
